import { useId } from 'react';

type StationProps = {
  className?: string;
};

export function Station({ className }: StationProps) {
  const uid = useId().replace(/:/g, '');
  const bodyId = `${uid}-body`;
  const dishId = `${uid}-dish`;

  return (
    <svg className={className} viewBox="0 0 400 400" fill="none" aria-hidden="true">
      <defs>
        <radialGradient id={bodyId} cx="38%" cy="32%" r="68%">
          <stop offset="0%" stopColor="#4a5563" />
          <stop offset="42%" stopColor="#1c242e" />
          <stop offset="100%" stopColor="#0a0c10" />
        </radialGradient>
        <radialGradient id={dishId} cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="#c4001a" />
          <stop offset="35%" stopColor="#3a1216" />
          <stop offset="100%" stopColor="#141920" />
        </radialGradient>
      </defs>
      <circle cx="200" cy="200" r="188" fill={`url(#${bodyId})`} />
      <circle cx="200" cy="200" r="188" stroke="rgba(138,166,188,0.22)" strokeWidth="1" />
      {Array.from({ length: 10 }, (_, index) => (
        <ellipse
          key={`lat-${index}`}
          cx="200"
          cy="200"
          rx="188"
          ry={18 + index * 17}
          stroke="rgba(238,243,248,0.06)"
          strokeWidth="1"
        />
      ))}
      {Array.from({ length: 12 }, (_, index) => {
        const angle = (index * Math.PI) / 12;
        const x = 200 + Math.cos(angle) * 188;
        const y = 200 + Math.sin(angle) * 188;
        return <line key={`mer-${index}`} x1="200" y1="200" x2={x} y2={y} stroke="rgba(238,243,248,0.05)" />;
      })}
      <rect x="16" y="192" width="368" height="16" fill="#07080a" opacity="0.88" />
      <rect x="16" y="196" width="368" height="3" fill="#8aa6bc" opacity="0.28" />
      <circle cx="138" cy="132" r="38" fill={`url(#${dishId})`} />
      <circle cx="138" cy="132" r="22" stroke="#c4001a" strokeWidth="1.5" opacity="0.85" />
      <circle cx="138" cy="132" r="6" fill="#ff2a2a" />
    </svg>
  );
}
